import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import ptBR from './locales/pt-BR/common.json';
import en from './locales/en/common.json';
import floating from './lib/floating';

// pt-BR is the default and fallback language (the operators are Brazilian);
// en is provided as a secondary fallback. Mirrors services/client-portal.
floating(
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        'pt-BR': { common: ptBR },
        en: { common: en },
      },
      fallbackLng: 'pt-BR',
      supportedLngs: ['pt-BR', 'en'],
      defaultNS: 'common',
      interpolation: { escapeValue: false },
      detection: {
        order: ['localStorage', 'navigator', 'htmlTag'],
        caches: ['localStorage'],
      },
    }),
);

export default i18n;
